import React from 'react';
import { LinearProgress, LinearProgressProps } from '@mui/material';
import Box from '@mui/material/Box';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 16px;
`;

const ProgressText = styled(Box)`
    font-size: 14px;
`;

const LinearProgressWithLabel = (props: LinearProgressProps & { value: number }) => (
    <Container>
        <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant="determinate" {...props} />
        </Box>
        <ProgressText sx={{ minWidth: 35 }}>
            {`${Math.round(props.value)}%`}
        </ProgressText>
    </Container>
);

export default LinearProgressWithLabel;
